module.exports = __webpack_public_path__ + "img/woman_child_face.7e72c44c.png";